import { render, staticRenderFns } from "./mock-phone.vue?vue&type=template&id=c9c41196&scoped=true&"
import script from "./mock-phone.vue?vue&type=script&lang=js&"
export * from "./mock-phone.vue?vue&type=script&lang=js&"
import style0 from "./mock-phone.vue?vue&type=style&index=0&id=c9c41196&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c41196",
  null
  
)

export default component.exports